module["exports"] = [
  "საქართველო"
];
